import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'getTicketStatus' })
export class TicketStatusPipe implements PipeTransform {

    transform(value: number): string {

        switch ( value ) {
            case 0:
                return 'New';
            case 1:
                return 'In Progress';
            case 2:
                return 'Awaiting Member';
            case 3:
                return 'Awaiting Admin';
            case 4:
                return 'TOS';
            case 99:
                return 'Closed';
            default:
                return 'N/A'
        }

    }

}


@Pipe({ name: 'getTicketStatusCSS' })
export class TicketStatusCSSPipe implements PipeTransform {

    transform(value: number): string {

        switch ( value ) {
            case 0:
                return 'New';
            case 1:
                return 'InProgress';
            case 2:
                return 'AwaitingMember';
            case 3:
                return 'AwaitingAdmin';
            case 4:
                return 'TOS';
            case 99:
                return 'Closed';
            default:
                return '';
        }

    }

}
